import CONST_STORAGE from 'constants/storage';

export const setCurrentSearchTerm = (term: string) =>
  localStorage.setItem(CONST_STORAGE.FILTERS.CURRENT_SEARCH_TERM, term);

export const getCurrentSearchTerm = () =>
  localStorage.getItem(CONST_STORAGE.FILTERS.CURRENT_SEARCH_TERM);

export const removeCurrentSearchTerm = localStorage.removeItem(
  CONST_STORAGE.FILTERS.CURRENT_SEARCH_TERM,
);

export const setAdvancedSearch = (advanced: string) => 
  localStorage.setItem(CONST_STORAGE.FILTERS.CURRENT_ADVANCED_SEARCH_TERM, advanced);

export const getAdvancedSearch = () => 
  localStorage.getItem(CONST_STORAGE.FILTERS.CURRENT_ADVANCED_SEARCH_TERM);

export const setAdvancedSearchObject = (searchedTerm: string) =>
  localStorage.setItem(CONST_STORAGE.FILTERS.CURRENT_ADVANCED_SEARCH_OBJECT, searchedTerm);

export const getAdvancedSearchObject = () =>
  localStorage.getItem(CONST_STORAGE.FILTERS.CURRENT_ADVANCED_SEARCH_OBJECT);